import React from 'react';
import TimeInProgressField from 'domain/sales/projectsDashboard/shared/field/TimeInProgressField';
import ProgressField from 'domain/sales/projectsDashboard/shared/field/ProgressField';
import CompanyLinkField from 'domain/sales/projectsDashboard/shared/field/CompanyLinkField';
import ProjectDashboardLegend from 'domain/sales/projectsDashboard/shared/ProjectsDashboardLegend';
import {
  DataGridInfiniteScrollPagingHandler,
  DataGridLayout,
  ListLoadingDecorator,
  RowWithDetailsPanel,
  useListContext,
} from 'framework/list';
import { TextField } from 'framework/ui/field';
import ProjectStageField from 'domain/sales/projectsDashboard/shared/field/ProjectStageField';
import { EmployeeLinkField } from 'domain/shared/employee';
import { notStaffingPredicate, PROGRESS_STATUSES } from 'domain/sales/projectsDashboard/useProjectsDashboardService';
import { findLast, orderBy } from 'lodash';

const projectsDashboardTableSx = {
  '& .list-general': {
    tableLayout: 'auto',
    minWidth: '1080px',
    '& th:nth-child(2), & td:nth-child(2)': {
      pr: '18px',
      pl: '12px',
    },
  },
  '& tbody .highlighted': {
    backgroundColor: 'background.error',
  },
};

const ProjectsDashboardsDataGrid = () => {
  const { data: { items = [] } = {}, loading } = useListContext();

  return (
    <>
      <DataGridInfiniteScrollPagingHandler>
        <DataGridLayout
          sxTableWrapper={projectsDashboardTableSx}
          rowKeySource="leadId"
          tableRowComponent={RowWithDetailsPanel}
          rowProps={(item: Dictionary<string>) => {
            const progressSteps = item?.progress as unknown as any[];
            const currentStep =
              progressSteps?.find(
                (step: any) =>
                  PROGRESS_STATUSES.IN_PROGRESS_WITH_DELAY === step.status && notStaffingPredicate(step.stepName),
              ) ||
              findLast(
                orderBy(progressSteps, ['stepNumber'], ['asc']),
                step => step.status !== PROGRESS_STATUSES.NOT_STARTED && notStaffingPredicate(item.stepName),
              );
            const isHighlighted = [
              PROGRESS_STATUSES.IN_PROGRESS_WITH_DELAY,
              PROGRESS_STATUSES.COMPLETED_WITH_DELAY,
            ].includes(currentStep.status);

            return { className: isHighlighted ? 'highlighted' : '' };
          }}
        >
          <ProgressField isDetailsPanel label=" " source="progress" width={40} />
          <CompanyLinkField source="companyName" label="ID" />
          <TextField source="opportunityName" label="Opportunity name" />
          <TextField source="accountCodeName" label="Account name" />
          <EmployeeLinkField source="ownerAlias" nameSource="ownerName" label="Owner" />
          <ProjectStageField source="progress" label="Current State" width={205} />
          <TimeInProgressField
            source="leadCreationDate"
            customerActivityDurationSource="customerActivityDuration"
            label="Time elapsed"
            shouldCountFromTargetDate
            progressSource="progress"
            width={200}
          />
          <TimeInProgressField
            source="targetDate"
            customerActivityDurationSource="customerActivityDuration"
            label="Time remaining"
            progressSource="progress"
            width={200}
          />
        </DataGridLayout>
      </DataGridInfiniteScrollPagingHandler>
      <ListLoadingDecorator items={items} loading={loading}>
        {!!items.length && <ProjectDashboardLegend rowDirection />}
      </ListLoadingDecorator>
    </>
  );
};

export default ProjectsDashboardsDataGrid;
